import { FunctionComponent, ReactNode } from "react";
import Icon from "@mdi/react";

interface EmptyStateProps {
  title: string;
  message?: string;
  imageSrc?: string;
  icon?: string;
  action?: ReactNode;
}

const EmptyState: FunctionComponent<EmptyStateProps> = ({
  title,
  message,
  imageSrc,
  icon,
  action,
}) => {
  return (
    <div className="w-full flex justify-center items-center py-16">
      <div className="flex flex-col items-center text-center gap-3">
        {imageSrc ? (
          <img src={imageSrc} alt="" className="w-40 h-40 md:w-48 md:h-48" />
        ) : icon ? (
          <Icon path={icon} className="h-16 w-16 text-gray-300" />
        ) : null}
        <div className="text-lg md:text-xl font-semibold text-gray-600">
          {title}
        </div>
        {message && (
          <div className="text-sm text-gray-400 max-w-sm">{message}</div>
        )}
        {action && <div className="mt-2">{action}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
